import React from 'react';
import TrialStatusModal from '../TrialStatusModal';
import SubscriptionExpiredModal from '../SubscriptionExpiredModal';

interface ExpirationModalsProps {
  isTrialExpiredModalOpen: boolean;
  isTrialAdmin: boolean;
  closeTrialExpiredModal: () => void;
  isSubscriptionExpiredModalOpen: boolean;
  isSubscriptionAdmin: boolean;
  closeSubscriptionExpiredModal: () => void;
}

const ExpirationModals: React.FC<ExpirationModalsProps> = ({
  isTrialExpiredModalOpen,
  isTrialAdmin,
  closeTrialExpiredModal,
  isSubscriptionExpiredModalOpen,
  isSubscriptionAdmin,
  closeSubscriptionExpiredModal
}) => {
  return (
    <>
      <TrialStatusModal 
        isOpen={isTrialExpiredModalOpen} 
        onClose={closeTrialExpiredModal} 
        isAdmin={isTrialAdmin}
        status="expired"
      />
      
      <SubscriptionExpiredModal 
        isOpen={isSubscriptionExpiredModalOpen} 
        onClose={closeSubscriptionExpiredModal} 
        isAdmin={isSubscriptionAdmin} 
      />
    </>
  );
};

export default ExpirationModals; 